import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=68cb67b0"
import script from "./jurisdiction.vue?vue&type=script&lang=js"
export * from "./jurisdiction.vue?vue&type=script&lang=js"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=68cb67b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports